import { Anchor, spaceMixin, token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledHorizontalCard = styled(Anchor)`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.$isExpired ? '20px' : spaceMixin('sm'))} 21px;
  margin-bottom: ${spaceMixin('xs')};
  border: 1px solid ${(props) => (props.$isMessageOwner ? token('colors.blue200') : token('colors.gray300'))};
  border-radius: ${(props) => (props.$isMessageOwner ? '24px 24px 0 24px' : '0 24px 24px 24px')};
  text-decoration: none;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const StyledContent = styled.div`
  width: 140px;
  margin-right: ${spaceMixin('sm')};
`;

export const StyledExpiredContent = styled.div`
  width: 177px;
`;
